<template>
    <filters-wrapper :has-active-filters="hasActiveFilters" @submit="submit" @reset="reset">
        <template v-slot:panel>
            <FilterStatusToggle v-model="filters.active" @update:model-value="submit" />
        </template>
        <v-form class="mb-5 table-filters">
            <v-row dense>
                <v-col cols="12" md="6">
                    <daterange
                        :start-date-label="$t('created_date_from')"
                        :end-date-label="$t('created_date_to')"
                        dense
                        :single-line="false"
                        :hide-details="false"
                        :min-start-date="null"
                        same-date
                        :_start-date="filters.createdDateFrom"
                        :_end-date="filters.createdDateTo"
                        @change-start-date="filters.createdDateFrom = $event"
                        @change-end-date="filters.createdDateTo = $event"
                    />
                </v-col>
                <v-col cols="12" md="6">
                    <daterange
                        :start-date-label="$t('modified_date_from')"
                        :end-date-label="$t('modified_date_to')"
                        dense
                        :single-line="false"
                        :hide-details="false"
                        :min-start-date="null"
                        same-date
                        :_start-date="filters.modifiedDateFrom"
                        :_end-date="filters.modifiedDateTo"
                        @change-start-date="filters.modifiedDateFrom = $event"
                        @change-end-date="filters.modifiedDateTo = $event"
                    />
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="filters.subject" :label="$t('title')" density="compact" />
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="filters.description" :label="$t('internal_note', 1)" density="compact" />
                </v-col>
                <v-col v-if="!preset" cols="12" md="3">
                    <v-text-field v-model="filters.orderId" :label="$t('order_number')" density="compact" />
                </v-col>
            </v-row>
        </v-form>
    </filters-wrapper>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'
    import Daterange from '@/components/search/forms/Daterange.vue'

    @Component({
        components: {Daterange},
    })
    export class CommunicationsFilters extends Vue {
        @VModel() filters
        @Prop({required: true, type: Boolean}) hasActiveFilters
        @Prop({default: false, type: Boolean}) preset

        @Emit()
        submit() {}

        @Emit()
        reset() {}
    }

    export default CommunicationsFilters
</script>
